// src/components/MatchTable.js

import React from "react";

/**
 * MatchTable component
 * @param {Array} columns - Column definitions with header and render function
 * @param {Array} data - Data array to display
 * @param {Object} cellStyle - Default cell styling
 * @param {Function} rowClassName - Function to determine row class based on data
 * @param {Function} onRowAction - Optional callback when row action is triggered (matchId, teamName)
 * @param {Boolean} showActions - Whether to show the actions column
 * @param {Function} onRowClick - Optional callback when row is clicked
 */
const MatchTable = ({ columns, data, cellStyle, rowClassName, onRowAction, showActions = false, onRowClick }) => {
    const allColumns = showActions ? [...columns] : columns;

    return (
        // --- Add the Bootstrap responsive wrapper div here ---
        <div className="table-responsive">
            <table className="table">
                <thead>
                    <tr>
                        {allColumns.map((col, idx) => (
                            <th key={idx} style={{ ...cellStyle, ...col.headerStyle }}>
                                {col.header}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {data.length === 0 ? (
                        <tr>
                            <td style={cellStyle} colSpan={allColumns.length}>
                                No data found
                            </td>
                        </tr>
                    ) : (
                        data.map((item, idx) => {
                            const hasRowClick = onRowClick && typeof onRowClick === 'function';
                            const baseClassName = rowClassName ? rowClassName(item.gender) : "";
                            const combinedClassName = hasRowClick ? `${baseClassName} clickable-row`.trim() : baseClassName;

                            return (
                                <tr
                                    key={item.key || `${item.dateAndTime}-${item.homeTeam}-${idx}`}
                                    className={combinedClassName}
                                    onClick={hasRowClick ? () => onRowClick(item) : undefined}
                                    style={hasRowClick ? { cursor: 'pointer' } : undefined}
                                >
                                    {columns.map((col, cidx) => (
                                        <td key={cidx} style={{ ...cellStyle, ...col.cellStyle }} >
                                            {col.render ? col.render(item) : item[col.accessor]}
                                        </td>
                                    ))}
                                </tr>
                            );
                        })
                    )}
                </tbody>
            </table>
        </div> // --- Close the wrapper div ---
    );
};

export default MatchTable;